import { render, staticRenderFns } from "./SlideHome.vue?vue&type=template&id=03715efc"
import script from "./SlideHome.vue?vue&type=script&lang=js"
export * from "./SlideHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03715efc')) {
      api.createRecord('03715efc', component.options)
    } else {
      api.reload('03715efc', component.options)
    }
    module.hot.accept("./SlideHome.vue?vue&type=template&id=03715efc", function () {
      api.rerender('03715efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/SlideHome.vue"
export default component.exports